import { FilterMetadata, SortMeta } from 'primeng/api'

import { StaticDropDown } from '@app/components/generic/generic'
import { GenericColumnComponent } from '@app/components/generic/generic-column'

export interface Filter extends FilterMetadata {
  // These are inherited:
  // value?: any;
  // matchMode?: string;
  // operator?: string; // always AND for acted

  // this will hold the value of `columnComponent.filterKey || columnComponent.key`,
  // used to determine the specific columnComponent to use from the value found in the URL
  filterKey?: string
  // this will hold columnComponent.key, used to determine the specific columnComponent to use
  // when the configure filters choose field widget is used
  columnKey?: string
  // a reference to the instance of the column impacted by the filter
  columnComponent?: GenericColumnComponent
  filterMatchModes: StaticDropDown[]
}

export function newFilter (): Filter {
  return {
    filterMatchModes: [],
  }
}

export interface FilterServicePayload {
  filters: Filter[],
  multiSortMeta: SortMeta[],
  rows: number
  first: number
}

export function newFilterServicePayload (): FilterServicePayload {
  return {
    filters: [],
    multiSortMeta: [],
    rows: 100,
    first: 0,
  }
}
